export const config = {
  serverURL: "https://qf9pbimq0c.execute-api.us-east-1.amazonaws.com/qa/api/v1.0",
  NXTServerURL: "https://{tenant}.qa.mktnxt.com",
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "qa",
  clientId: "2ed144u1gvfbt5vbbonec8q4tg",
  cognitoDomain: "marketron-dev.auth.us-east-1.amazoncognito.com",
  identityProvider: "marketron-dev.com",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-qa.mediascape-dev.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_s6bRlZd0d",
};
